T.CaseStudies = Class(
	/**
	 * @lends {T.CaseStudies#}
	 */
	{
		/**
		 * @param {string} type
		 * @param {DR.ApiCall} apiCall
		 * @param {{pseudoType:String}} par
		 */
		__construct( type, apiCall, par = {} ) {
			let key = type;
			if( par.pseudoType ) {
				key = par.pseudoType;
			}
			this.node = mkE({
				tag: 'div',
				id: 't-case-studies',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get(`case-studies.${key}.title`)
							},
							D.Lang.exists(`case-studies.${key}.underline`) ? {
								tag: 'p',
								className: 'underline',
								text: D.Lang.get(`case-studies.${key}.underline`)
							} : '',
							{
								tag: 'div',
								className: 'items',
								els: [
									this._sliderNode = mkE({
										tag: 'div',
										className: 'glide',
										style: {
											display: 'flex'
										},
										els: [
											{
												tag: 'div',
												className: 'glide__track',
												attr: {
													"data-glide-el": 'track'
												},
												els: [
													this._casesNode = mkE({
														tag: 'div',
														className: 'glide__slides'
													}),
													{
														tag: 'div',
														className: 'glide__arrows',
														attr: {
															"data-glide-el": "controls"
														},
														els: [
															{
																tag: 'button',
																className: 'glide__arrow glide_arrow--left',
																attr: {
																	"data-glide-dir": '<'
																}
															},
															{
																tag: 'button',
																className: 'glide__arrow glide_arrow--right',
																attr: {
																	"data-glide-dir": '>'
																}
															}
														]
													},
													this._controlsNode = mkE({
														tag: 'div',
														className: 'glide__bullets',
														attr: {
															"data-glide-el": 'controls[nav]'
														}
													})
												]
											}
										]
									})
								]
							}
						]
					}
				]
			});

			this._mGetCaseStudies = new DR.casestudies.GetAll();
			this._mGetCaseStudies.pg = 1;
			this._mGetCaseStudies.count = 10;
			this._mGetCaseStudies.section = type;
			this._mGetCaseStudies.select = [
				new DR.casestudies.select.Item().url().title().cover().coverMobile(),
				new DR.roadgames.select.Image().all()
			];
			this._mGetCaseStudies.onLoad = this._mGetCaseStudiesRe;
			this._mGetCaseStudies.onError = this._mGetCaseStudiesError;
			apiCall.addMethod(this._mGetCaseStudies);
		},

		_mGetCaseStudiesRe() {
			for( let i = 0, l = this._mGetCaseStudies.re.items.length; i < l; i++ ) {
				const item = this._mGetCaseStudies.re.items[i];
				mkE({
					tag: 'button',
					className: 'glide__bullet',
					attr: {
						"data-glide-dir": `=${i}`
					}
				}).append(this._controlsNode)
				new T.CaseStudies.Item(item).append(this._casesNode);
			}

			if( this._mGetCaseStudies.pg === 1 && !this._mGetCaseStudies.re.items.length ) {
				this.onLeave();
				this.remove();
			}
		},

		_mGetCaseStudiesError() {
			if( this._mGetCaseStudies.pg === 1 ) {
				this.onLeave();
				this.remove();
			}
		},

		goTo( index ) {
			if( !this._slider ) {
				return;
			}
			this._slider.go('=' + index);
		},

		onShow() {
			D.onLoad('Glide', D.closure(this, this._initSlider));
		},

		_initSlider() {
			if( this._casesNode.childNodes.length === 0 ) {
				return;
			}
			this._slider = new Glide(this._sliderNode, {
				type: 'carousel',
				startAt: 0,
				perView: 1,
				focusAt: 'center',
				dragThreshold: false,
				autoplay: 15000
			});
			this._slider.mount();
		},

		onLeave() {
			if( this._slider ) {
				this._slider.destroy();
			}
		}
	},
	mkE.Base
);

T.CaseStudies.Item = Class(
	/**
	 * @lends {T.CaseStudies.Item#}
	 */
	{
		/** @param {DR.casestudies.struct.Item} item */
		__construct( item ) {
			const isMobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			var imageSet = function ( item ) {
				const dpi = window.devicePixelRatio;
				if( dpi <= 1 ) {
					return item.small;
				} else if( dpi > 1 && dpi <= 2 ) {
					return item.medium;
				} else {
					return item.large;
				}
			};
			this.node = mkE({
				tag: 'div',
				className: 'glide__slide',
				els: [
					{
						tag: 'a',
						href: D.url(item.url),
						className: 'case-study',
						style: {
							backgroundImage: isMobile ? `url(${imageSet(item.coverMobile.image)})` : `url('${item.cover.image.large}')`
						},
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: item.title
							},
							{
								tag: 'div',
								className: 'button-container',
								els: [
									{
										tag: 'div',
										className: 'button button-pink',
										text: D.Lang.get('case-studies.slider.show_more')
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);